import { Controller } from "@hotwired/stimulus"

// "Shipping address is the same as billing" (TMS-1548): on by default; turning it off reveals
// a full delivery address. Hidden fields are disabled so they are not submitted.
export default class extends Controller {
  static targets = ["checkbox", "fields"]

  connect() {
    this.sync()
  }

  sync() {
    const separate = !this.checkboxTarget.checked
    this.fieldsTarget.hidden = !separate
    this.fieldsTarget.querySelectorAll("input, button, select").forEach((element) => {
      if (separate) {
        // The state inputs that don't match the country stay disabled (store-address owns them).
        if (!element.closest("[hidden]")) element.disabled = false
      } else {
        element.disabled = true
      }
    })
  }
}
